// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { useWebhooksRequestConfig } from 'hooks/useWebhooksBaseUrl'
import {
  postNotificationDestinations,
  PostNotificationDestinationsRequest,
} from 'services/WebHooksService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useCreateNotificationDestinationsMutation = () => {
  const requestConfig = useWebhooksRequestConfig()
  return useMutation({
    mutationFn: (data: Omit<PostNotificationDestinationsRequest, keyof typeof requestConfig>) =>
      postNotificationDestinations({ ...data, ...requestConfig }),
    onError(error: BaseErrorResponse, data) {
      logSentryError('Error from useCreateWebhookDestinationsMutation', error, data)
    },
  })
}
